'use strict';

// this file was created to prevent NativeReanimated from being included in the web bundle
export { default } from "../js-reanimated/index.js";
//# sourceMappingURL=index.web.js.map